import { Settings2 } from 'lucide-react';
import type { BlockType } from '@pageboss/shared';
import { cn } from '@/lib/utils';

// =====================================================================
// Hover-pill chip on complex canvas blocks — "Click to edit options".
// Reveals on hover/focus of the parent (.group); pointer-events-none so
// it never blocks the underlying click. The block itself handles the
// click via onSelect → setSelectedBlockId.
// =====================================================================

// Which block types open the inspector when clicked.
//   3B-3d.a — services, credentials
//   3B-3d.b — + pricing, gallery
//   3B-3d.c — + testimonials, team
//   3B-3d.d — + contact, faq (closed the 8-block "complex" scope)
//   3B-3d.e (this commit) — + hero, footer (panel-driven editing for
//                            the simple-but-prop-heavy blocks; inline
//                            contenteditable on text fields stays)
//
// Pure-text blocks (about, cta, heading, text) remain inline-only —
// they have no array/toggle/URL props that need a panel.
export const INSPECTOR_ENABLED_BLOCKS: ReadonlySet<BlockType> = new Set<BlockType>([
  'services',
  'credentials',
  'pricing',
  'gallery',
  'testimonials',
  'team',
  'contact',
  'faq',
  'hero',
  'footer',
]);

export function blockOpensInspector(type: BlockType): boolean {
  return INSPECTOR_ENABLED_BLOCKS.has(type);
}

export function CanvasHoverPill() {
  return (
    <div
      className={cn(
        'pointer-events-none',
        'absolute left-3 top-3 z-10',
        'inline-flex items-center gap-1.5',
        'h-6 px-2 rounded-full',
        'bg-card border border-border',
        'text-xs font-semibold uppercase tracking-wide',
        'text-brand-700',
        'opacity-0 group-hover:opacity-100 group-focus-within:opacity-100',
        'transition-opacity duration-[var(--duration-fast)]',
      )}
      aria-hidden
    >
      <Settings2 className="h-3 w-3" />
      Click to edit options
    </div>
  );
}
